import { render, staticRenderFns } from "./weicheng.vue?vue&type=template&id=0633071d&scoped=true"
import script from "./weicheng.vue?vue&type=script&lang=js"
export * from "./weicheng.vue?vue&type=script&lang=js"
import style0 from "./weicheng.vue?vue&type=style&index=0&id=0633071d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0633071d",
  null
  
)

export default component.exports